import * as e from "react";
const m = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M29 8.75H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5z" }));
export {
  m as ReactComponent
};
